import React, { useEffect } from "react";

const MaloniToken = () => {
  const queryParams = new URLSearchParams(window.location.search);

  const myParam = queryParams.get("q");

  useEffect(() => {
    const timer = setTimeout(() => {
      window.close();
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-md-12 mt-5 text-center">
            {myParam === "success" ? (
              <div className="alert alert-success">
                Moloni successfully connected.
              </div>
            ) : (
              <div className="alert alert-danger">
                Oops...something went wrong. Please try again.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaloniToken;
